"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MultiTargetStrategy_1 = require("./MultiTargetStrategy");

var StrategyTypeEnum_1 = require("./StrategyTypeEnum");
/**
 * Define the relations with the relevant competitors. Only one strategy and distance can be applied.
 *
 * @author RV
 */


var FollowCheapest =
/*#__PURE__*/
function (_MultiTargetStrategy_) {
  _inherits(FollowCheapest, _MultiTargetStrategy_);

  /**
   * @param competitorIds
   */
  function FollowCheapest(competitorIds) {
    var _this;

    _classCallCheck(this, FollowCheapest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FollowCheapest).call(this, competitorIds));
    _this.competitorIds = competitorIds;
    return _this;
  }

  _createClass(FollowCheapest, [{
    key: "getType",
    value: function getType() {
      return StrategyTypeEnum_1.StrategyTypeEnum.FollowCheapest;
    }
  }]);

  return FollowCheapest;
}(MultiTargetStrategy_1.MultiTargetStrategy);

exports.FollowCheapest = FollowCheapest;